import { useEffect } from 'react';
import { useGlobal } from '../../hooks';
import { useFetchConfig } from './useConfig';
import { setSentryAccount } from '../../sentry';

export const ConfigFetcher = (): null => {
    const { accountId, setConfig, config, setIsReady } = useGlobal();
    const { data, isLoading } = useFetchConfig({
        accountId: accountId,
        enabled: !!accountId && !config,
    });

    useEffect(() => {
        if (data && !isLoading) {
            setConfig(data);
            setSentryAccount(data.account.name);
        }
        setIsReady(!isLoading);
    }, [data, isLoading]);

    return null;
};
